import { Dealer, Department } from "../models";
import { SuburbModel } from "../models/SuburbModel";

import { observable, makeObservable } from "mobx";
import CustomEvent from "custom-event";
import { ApiBasePath } from "../utils/ApiBasePath";
import * as Request from "superagent";

// dealers list
//const data = require("../temp.json");
const log: boolean = document.location.href.indexOf("?log") !== -1;

export default class FindDealerStore {
  @observable dealerSelects: number = 0;
  @observable isRestored: boolean = null;
  @observable suburb: SuburbModel = null;
  @observable dealers: Dealer[] = [];
  @observable filteredDealers: Dealer[] = [];
  @observable departments: Department[] = [];
  @observable selectedDealer: Dealer = null;
  @observable isFetching: boolean = true;
  @observable isFetchingDepartments: boolean = true;
  @observable departmentsFilter: string = null;
  @observable sizeFilter: number = null;
  @observable rating: number = null;
  @observable dealersLoaded: boolean = false;

  constructor(
    suburb: SuburbModel | null,
    departmentsFilter?: string,
    sizeFilter?: number
  ) {
    makeObservable(this);
    this.suburb = suburb;
    this.departmentsFilter = departmentsFilter || "Vehicle Sales";
    this.sizeFilter = sizeFilter || 0;

    window.addEventListener("locationSelected", (e: any) => {
      const ready = () => {
        this.isRestored = e.detail.isRestored;
        this.suburb = e.detail.suburb;

        this.fetchDealers(true);
      };

      if (document.readyState === "complete") {
        ready();
      } else {
        window.addEventListener("load", () => {
          log && console.log("Delay location restore until load.");
          ready();
        });
      }
    });
    // this.fetchDepartments();

  }

  showPostcodeOverlayActive() {
    const evt = new CustomEvent("selectLocation", { detail: {} });
    window.dispatchEvent(evt);
  }

  selectDealer = (dealer, ignoreEvent: boolean = false) => {
    this.dealerSelects++;
    if (this.dealerSelects > 1 && this.isRestored === true) {
      this.isRestored = false;
    }
    this.selectedDealer = dealer;

    if (!ignoreEvent) {
      const evt = new CustomEvent("dealerSelected", { detail: { dealer } });
      window.dispatchEvent(evt);
    }
  };

  setRating = (rating) => {
    this.rating = rating;
  };

  fetchDealers = (setDefaultDealer: boolean) => {
    this.isFetching = true;
    let url;
    if (this.departmentsFilter !== "all") {
      const appendSuburbName = this.suburb
        ? `&SuburbName=${this.suburb.name}`
        : "";
      const appendPostcode = this.suburb
        ? `&PostCode=${this.suburb.postcode}`
        : "";
      url = `${ApiBasePath.dealers}?DepartmentName=${this.departmentsFilter}${appendPostcode}${appendSuburbName}`;
    } else {
      const appendPostcode = this.suburb
        ? `&PostCode=${this.suburb.postcode}`
        : "";
      url = `${ApiBasePath.dealers}?DepartmentName=Vehicle Sales${appendPostcode}`;
    }

    if (this.sizeFilter > 0) {
      url = url + "&top=" + this.sizeFilter;
    }
    const carmodel = this.getParameterByName("model");
    url = `${url}${
      carmodel === "wrx sti" ? "&IsWRXSTI=True" : "&IsWRXSTI=False"
    }${carmodel === "solterra" ? "&IsElectric=True" : "&IsElectric=False"}`;

    Request.get(url).then(
      (response) => {
        this.dealers = response.body;
        this.isFetching = false;
        this.dealersLoaded = true;

        if (response.body.length > 0) {
          setDefaultDealer && this.selectDealer(response.body[0]);
        }
      },
      (error) => {
        console.log("An error occurred loading dealers.");
        this.isFetching = false;
      }
    );
  };

  fetchDepartments = () => {
    const url = `${ApiBasePath.dealers}/departments`;

    this.isFetchingDepartments = true;

    Request.get(url).then(
      (response) => {
        this.departments = response.body;
        this.isFetchingDepartments = false;
      },
      (error) => {
        console.log("An error occurred loading departments.");
        this.isFetchingDepartments = false;
      }
    );
  };

  setDepartmentsFilter = (departmentName) => {
    this.departmentsFilter = departmentName;
    const setDefaultDealer = !!this.selectedDealer || !!this.suburb;
    this.fetchDealers(setDefaultDealer);
  };
  getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };
}
